// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimNoteDto
 */
export interface IClaimNoteDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimNoteDto
     */
    claim_note_type?: IClaimNoteDtoClaimNoteTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimNoteDto
     */
    claim_note_group?: IClaimNoteDtoClaimNoteGroupEnum;
    /**
     * 
     * @type {Date}
     * @memberof IClaimNoteDto
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IClaimNoteDto
     */
    metadata?: string;
}

/**
* @export
* @enum {string}
*/
export enum IClaimNoteDtoClaimNoteTypeEnum {
    SPEND_LIMIT_NOTE = 'SPEND_LIMIT_NOTE',
    NO_PAY_OUT_NOTE = 'NO_PAY_OUT_NOTE',
    CHECK_EXPIRED_NOTE = 'CHECK_EXPIRED_NOTE',
    CHECK_VOIDED_NOTE = 'CHECK_VOIDED_NOTE',
    WAITING_FOR_FUNDS_EXPIRED = 'WAITING_FOR_FUNDS_EXPIRED',
    ELECTION_LIMIT_NOTE = 'ELECTION_LIMIT_NOTE',
    PERSON_SPEND_LIMIT_NOTE = 'PERSON_SPEND_LIMIT_NOTE',
    CATEGORY_SPEND_LIMIT_NOTE = 'CATEGORY_SPEND_LIMIT_NOTE',
    FRAUD_CLAIM_NOTE = 'FRAUD_CLAIM_NOTE',
    CHECK_RETURNED_NOTE = 'CHECK_RETURNED_NOTE'
}
/**
* @export
* @enum {string}
*/
export enum IClaimNoteDtoClaimNoteGroupEnum {
    INFO = 'INFO',
    WARN = 'WARN'
}


/**
 * Check if a given object implements the IClaimNoteDto interface.
 */
export function instanceOfIClaimNoteDto(value: object): value is IClaimNoteDto {
    return true;
}

export function IClaimNoteDtoFromJSON(json: any): IClaimNoteDto {
    return IClaimNoteDtoFromJSONTyped(json, false);
}

export function IClaimNoteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimNoteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_note_type': json['claimNoteType'] == null ? undefined : json['claimNoteType'],
        'claim_note_group': json['claimNoteGroup'] == null ? undefined : json['claimNoteGroup'],
        'created_at': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function IClaimNoteDtoToJSON(json: any): IClaimNoteDto {
    return IClaimNoteDtoToJSONTyped(json, false);
}

export function IClaimNoteDtoToJSONTyped(value?: IClaimNoteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimNoteType': value['claim_note_type'],
        'claimNoteGroup': value['claim_note_group'],
        'createdAt': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'metadata': value['metadata'],
    };
}

